export const MAX_RO_COUNT_TO_REQUEST = 25;

export const RO_REQUEST_TIP = `Please enter up to ${MAX_RO_COUNT_TO_REQUEST} RO numbers ready for warranty processing separated by commas in this dialog box. E.g. 606672, 606674, 606678, 606691`;
